import { render, staticRenderFns } from "./course.vue?vue&type=template&id=64a76c70&scoped=true&"
import script from "./course.vue?vue&type=script&setup=true&lang=js&"
export * from "./course.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./course.vue?vue&type=style&index=0&id=64a76c70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a76c70",
  null
  
)

export default component.exports